module.exports = __webpack_public_path__ + "static/media/instagram-icon.0b8fd087.png";